import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardTitle, Collapse, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import MainMap from 'Components/MainMap/Index';
import voyager from '../../assets/images/map/voyager.png';
import google from '../../assets/images/map/google.jpg';
import topo from '../../assets/images/map/topo.jpg';
import openstreet from '../../assets/images/map/openstreet.jpg';
import * as url_helper from '../../helpers/url_helper'
import { Link } from 'react-router-dom';
import surfaceSvg from '../../assets/images/svg/surfaceWater.svg'
import layerSvg from '../../assets/images/svg/layer.svg'
import mainSvg from '../../assets/images/svg/mainLayer.svg'

const Dashboard: React.FC = () => {
  const optionGroup = [
    {
      label: "",
      options: [
        { label: "Улаанбаатар", value: "011" },
        { label: "Дорнод", value: "021" },
        { label: "Сүхбаатар", value: "022" }
      ]
    }
  ];
  const optionGroup_1 = [
    {
      label: "",
      options: [
        { label: "Баянгол", value: "01107" },
        { label: "Сүхбаатар", value: "01119" },
        { label: "Сонгино хайрхан", value: "01116" }
      ]
    }
  ];
  const optionGroup_3 = [
    {
      label: "",
      options: [
        { label: "Мөрөн, гол, горхи", value: "5101" },
        { label: "Булаг, шанд", value: "5102" },
        { label: "Нуур, цөөрөм, тойром", value: "5103" }
      ]
    }
  ];

  document.title = "E-Water";
  const [baseMap, setBaseMap] = useState("voyager")
  const [useAu1, setAu1] = useState(null) as any[];
  const [useAu2, setAu2] = useState(null) as any[];
  const [useLandUse, setLandUse] = useState(null) as any[];

  const [loaded, setLoaded] = useState(false)
  const [results, setResults] = useState([] as any)

  const [sav29GazarBoolean, setSav29GazarBoolean] = useState(false);
  const [riverBoolean, setRiverBoolean] = useState(false);
  const [arkhangaiRiverBoolean, setArkhangaiRiverBoolean] = useState(false);
  const [springBoolean, setSpringBoolean] = useState(false);

  const [col1, setcol1] = useState(false);
  const [col2, setcol2] = useState(false);
  const [col3, setcol3] = useState(false);

  const t_col1 = () => {
    setcol1(!col1);
    setcol2(false);
    setcol3(false);
  };

  const t_col2 = () => {
    setcol2(!col2);
    setcol1(false);
    setcol3(false);
  };

  const t_col3 = () => {
    setcol3(!col3);
    setcol1(false);
    setcol2(false);
  };

  const refreshMapData = async (search: any = "") => {

    setLoaded(false);
    let url = url_helper.MAP_GEO_SERVER + search;

    await fetch(encodeURI(url))
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.status === true) {
          setResults(responseJson.data);
        } else {
          setResults([]);
        }
      })
      .catch((error) => {
        setResults([]);
      })
      .finally(() => {
        setLoaded(true);
      });
  }

  const searchMap = () => {
    let search = "";
    search += "landuse:" + useLandUse.value + ';';
    search += "au1:" + useAu1.value + ';';
    search += "au2:" + useAu2.value;
    refreshMapData(search);
  }

  const mainFilter = {
    sav29Filter: sav29GazarBoolean,
    arkhangaiFilter: arkhangaiRiverBoolean,
  }

  const surfaceWaterFilter = {
    riverFilter: riverBoolean,
    springFilter: springBoolean,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Нүүр хуудас" breadcrumbItem="Нүүр хуудас" />
          <Card>
            <CardBody>
              {/* <Row>
                <div className="mb-3 d-flex gap-3">
                  <Select
                    placeholder="Аймаг/Нийслэл сонгох ..."
                    value={useAu1}
                    onChange={(value) => {setAu1(value)}}
                    options={optionGroup}
                    className="select2-selection col-lg-3" 
                  />
                
                  <Select
                    placeholder="Сум/Дүүрэг сонгох ..."
                    value={useAu2}
                    onChange={(value) => {setAu2(value)}}
                    options={optionGroup_1}
                    className="select2-selection col-lg-3"
                  />
                  <Select
                    placeholder="Хэрэглээний төрөл сонгох ..."
                    value={useLandUse}
                    onChange={(value) => {setLandUse(value)}}
                    options={optionGroup_3}
                    className="select2-selection col-lg-3"
                  />
                  <button 
                    onClick={() => {searchMap()}}
                    type="button"
                    className="btn btn-primary  btn-label"
                  >
                    <i className="mdi mdi-filter-plus-outline label-icon"></i> Хайх
                  </button>
                </div>
              </Row> */}

              <Card className='mainMap_filter'>
                <CardBody>
                  <CardTitle className='mb-3'> <img width={30} className='me-2' src={layerSvg} alt="" /> Давхаргын мэдээлэл</CardTitle>

                  <ul className="list-unstyled categories-list mb-0">
                    <li>
                      <div className="custom-accordion">
                        <Link className="text-body fw-medium py-1 d-flex align-items-center fw-semibold mb-2" onClick={t_col1} to="#">
                          <i className='me-2'> <img src={mainSvg} width={20} alt="" /> </i>{" "}
                          {/* <i className="mdi mdi-folder font-size-16 text-warning me-2"></i>{" "} */}
                          Үндсэн давхарга{" "}
                          <i
                            className={
                              col1
                                ? "mdi mdi-chevron-up accor-down-icon ms-auto"
                                : "mdi mdi-chevron-down accor-down-icon ms-auto"
                            }
                          />
                        </Link>
                        <Collapse isOpen={col1}>
                          <div className="card border-0 shadow-none ps-2 mb-0">
                            <ul className="list-unstyled mb-0">
                              <li>
                                <div className="form-check form-check-primary mb-3 ">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolor2"
                                    checked={sav29GazarBoolean}
                                    onChange={() => {
                                      setSav29GazarBoolean(!sav29GazarBoolean)
                                    }}
                                  />
                                  <label
                                    className="form-check-label fw-semibold"
                                    htmlFor="customCheckcolor2"
                                  >
                                    29 сав газар
                                  </label>
                                </div>
                              </li>
                              {/* <li>
                                <div className="form-check form-check-warning mb-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolor3"
                                    checked={arkhangaiRiverBoolean}
                                    onChange={() => {
                                      setArkhangaiRiverBoolean(!arkhangaiRiverBoolean)
                                    }}
                                  />
                                  <label
                                    className="form-check-label fw-semibold"
                                    htmlFor="customCheckcolor3"
                                  >
                                    Архангайн Гол
                                  </label>
                                </div>
                              </li> */}
                            </ul>
                          </div>
                        </Collapse>
                      </div>
                    </li>
                    <li>
                      <div className="custom-accordion">
                        <Link className="text-body fw-medium py-1 d-flex align-items-center fw-semibold mb-2" onClick={t_col2} to="#">
                          <i className="me-2"> <img src={surfaceSvg} width={20} alt="" /> </i>{" "}
                          Гадаргын ус{" "}
                          <i
                            className={
                              col2
                                ? "mdi mdi-chevron-up accor-down-icon ms-auto"
                                : "mdi mdi-chevron-down accor-down-icon ms-auto"
                            }
                          />
                        </Link>
                        <Collapse isOpen={col2}>
                          <div className="card border-0 shadow-none ps-2 mb-0">
                            <ul className="list-unstyled mb-0">


                              <li>
                                <div className="form-check form-check-success mb-3 ">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolor1"
                                    checked={riverBoolean}
                                    onChange={() => {
                                      setRiverBoolean(!riverBoolean)
                                    }}
                                  />
                                  <label
                                    className="form-check-label fw-semibold"
                                    htmlFor="customCheckcolor1"
                                  >
                                    Гол
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="form-check form-check-info ">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customCheckcolor4"
                                    checked={springBoolean}
                                    onChange={() => {
                                      setSpringBoolean(!springBoolean)
                                    }}
                                  />
                                  <label
                                    className="form-check-label fw-semibold"
                                    htmlFor="customCheckcolor4"
                                  >
                                    Булаг шанд
                                  </label>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </Collapse>
                      </div>
                    </li>

                  </ul>
                </CardBody>
              </Card>

              <div className='mapTypeSelection'>
                <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
              </div>

              <MainMap results={results} baseMap={baseMap} mainFilter={mainFilter} surfaceWaterFilter={surfaceWaterFilter} />

            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default Dashboard;